import { gql } from '@apollo/client';

export const CREATE_PRODUCT = gql`
  mutation CreateProduct($input: ProductInput!) {
    createProduct(input: $input) {
      _id
      productName
      amount
      questions
      scope
      description
      isActive
      isAddOn
    }
  }
`;

export const EDIT_PRODUCT = gql`
  mutation EditProductDetails($input: EditProductInput!) {
    editProductDetails(input: $input) {
      _id
      productName
      amount
      questions
      scope
      description
      isActive
      isAddOn
    }
  }
`;

export const DELETE_PRODUCT = gql`
  mutation DeleteProduct($productId: String!) {
    deleteProduct(productId: $productId) {
      acknowledged
      deletedCount
    }
  }
`;
